const DOCUMENT = {
  shipmentId: true,
  displayName: true,
  documentType: true,
  documentExtension: true,
  documentNumber: true,
  fileName: true,
  createdDateTime: true,
  atType: true,
  atBaseType: true
};
const DOCUMENTS = {
  orderId: true,
  shipmentId: true,
  documents: { ...DOCUMENT },
  relatedDocuments: { ...DOCUMENT }
};
export class ListDocumentsModel {
  /**
   *
   * @param shipmentId
   * @param carrierId
   * @param orderId
   */

    shipmentId: string = "";
    sourceTms: string = "";
    orderId: string = "";

  getListDocuments() {
    const input: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(this)) {
      if (typeof value !== "function") input[key] = value;
    }
    return {
      query: {
        listRelatedDocumentsV2: {
          __args: {
            documentMetaDataRequest: {
              ...input
            }
          },
          ...DOCUMENTS
        }
      }
    };
  }
}
